import React from 'react';
import parse from 'html-react-parser';

export default function ChecklistItemDescription({description}) {
  return description && (<div className="app-checklist-item-description">{parse(description)}</div>);
}
